import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { downloadResignationDocument, type ResignationDocument } from '@urbanik/api-client';
import { Button, CanonicalModal, CanonicalPdfViewer } from '@urbanik/ui';
import { RefreshCw } from 'lucide-react';
import { apiBase } from './api-base';

export function ResignationDocumentPreview({
  memberId,
  historyId,
  document,
  onClose,
}: {
  memberId: string;
  historyId: string;
  document: ResignationDocument;
  onClose: () => void;
}) {
  const [file, setFile] = useState<Blob | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setFile(null);
    setError('');
    setLoading(true);
    downloadResignationDocument(apiBase, memberId, historyId, document.id)
      .then((blob) => {
        if (active) setFile(blob);
      })
      .catch((e) => {
        if (active) setError(e instanceof Error ? e.message : 'No pudimos cargar la constancia.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [memberId, historyId, document.id, attempt]);
  return createPortal(
    <CanonicalModal
      open
      title="Vista previa de constancia"
      description={document.fileName}
      size="large"
      onClose={onClose}
    >
      <CanonicalPdfViewer
        file={file}
        fileName={document.fileName}
        loading={loading}
        error={error || undefined}
      />
      {error ? (
        <Button
          type="button"
          icon={<RefreshCw aria-hidden="true" />}
          onClick={() => setAttempt((n) => n + 1)}
        >
          Reintentar vista previa
        </Button>
      ) : null}
    </CanonicalModal>,
    window.document.body,
  );
}
